/* eslint-disable prettier/prettier */
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';

interface ConfirmDeleteModalProps {
  isOpen: boolean;
  names: string[]; 
  onCancel: () => void;
  onConfirm: () => void;
}

export const ConfirmDeleteModal = ({
  isOpen,
  names,
  onCancel,
  onConfirm,
}: ConfirmDeleteModalProps) => {
  const renderFileText = () => {
    if (names.length === 0) return 'these files';
    if (names.length === 1) return <span className="font-semibold text-secondary">{names[0]}</span>;
    if (names.length === 2) {
      return (
        <>
          <span className="font-semibold text-secondary">{names[0]}</span> and{' '}
          <span className="font-semibold text-secondary">{names[1]}</span>
        </>
      );
    }
    return <span className="font-semibold text-secondary">{names.length} files</span>;
  };

  return (
    <Modal isOpen={isOpen} onClose={onCancel} title="Confirm Deletion">
      <p className="mb-6 text-md text-muted-foreground">
        Are you sure you want to delete {renderFileText()}?
        <br />
        <span>This action cannot be undone.</span>
      </p>
      <div className="flex justify-end gap-3">
        <Button variant="secondary" onClick={onCancel} className="px-7 sm:px-10">
          Cancel
        </Button>
        <Button variant="danger" onClick={onConfirm} className="px-7 sm:px-10">
          Delete
        </Button>
      </div>
    </Modal>
  );
};
